// @ts-ignore

import { AcessoCbo } from 'graphql/types.generated'

/**
 * This file is automatically generated.
 *
 * To generate a new group of cbos follow this steps:
 *
 * Add a new enum inside of AcessoCbo enum, in AcessoCboAuth class.
 *
 * Still in AcessoCboAuth, map the new group enum with the list of cbos in 'mapping'
 * (you can use an initial if necessary. Ex.: all cbos related to a dental surgeon start with '2232', so you don't need to use a list with every cbos).
 *
 * Add the new group enum in AcessoCbo enum, in cbo.graphqls.
 *
 * Now, your application needs to be rebuilt and must be running on port 8080.
 *
 * Run 'yarn run gruposCbo:download' in the frontend folder.
 */

export type GrupoCbo = { grupo: AcessoCbo; cbos: string[] }
const GruposCbo = [
  {
    grupo: 'OUTRO_PROF_NIVEL_SUPERIOR',
    cbos: [
      '251605',
      '515305',
      '223405',
      '223415',
      '223425',
      '223410',
      '223445',
      '223430',
      '223650',
      '223605',
      '223660',
      '223655',
      '223635',
      '223630',
      '223810',
      '223840',
      '223815',
      '223830',
      '226305',
      '251545',
      '223710',
      '239415',
      '2241E1',
      '234410',
      '251550',
      '251555',
      '251510',
      '251515',
      '251540',
      '251535',
      '251505',
      '251520',
      '251525',
      '251530',
      '239425',
      '1312C1',
      '223905',
    ],
  },
  { grupo: 'CIRURGIAO_DENTISTA', cbos: ['2232'] },
  { grupo: 'TSB', cbos: ['322405', '322425'] },
  {
    grupo: 'AUXILIAR_OU_TECNICO_ENFERMAGEM',
    cbos: [
      '322205',
      '515110',
      '322230',
      '322250',
      '322235',
      '322240',
      '324210',
      '322245',
      '322210',
      '322215',
      '322220',
    ],
  },
  {
    grupo: 'ENFERMEIRO',
    cbos: [
      '223505',
      '223565',
      '223520',
      '223525',
      '223530',
      '223535',
      '223540',
      '223545',
      '223550',
      '223555',
      '223560',
      '223510',
    ],
  },
  {
    grupo: 'MEDICO',
    cbos: [
      '2231F9',
      '225103',
      '225105',
      '225106',
      '225109',
      '225110',
      '225112',
      '225115',
      '225118',
      '225120',
      '225121',
      '225122',
      '225124',
      '225125',
      '225127',
      '225130',
      '225133',
      '225135',
      '225136',
      '225139',
      '225140',
      '225142',
      '225145',
      '225148',
      '225150',
      '225151',
      '225154',
      '225155',
      '225160',
      '225165',
      '225170',
      '225175',
      '225180',
      '225185',
      '225195',
      '225203',
      '225210',
      '225215',
      '225220',
      '225225',
      '225230',
      '225235',
      '225240',
      '225250',
      '225255',
      '225260',
      '225265',
      '225270',
      '225275',
      '225280',
      '225285',
      '225290',
      '225295',
      '225305',
      '225310',
      '225315',
      '225320',
      '225325',
      '225330',
      '225335',
      '225340',
      '225345',
      '225350',
      '2231A2',
      '2231F8',
    ],
  },
]
export default GruposCbo
